// extracted by mini-css-extract-plugin
export default {"item":"Internal_item__Eiki6","icon":"Internal_icon__VQcI0","disabled":"Internal_disabled__6oyX9","chevron":"Internal_chevron__1vNYb"};